export default "__VITE_ASSET__1e48b32e__"